import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'react-jss';
import { PerformanceMarkerProvider } from '@bingads-webui-campaign-react/performance-marker-provider';
import { withComponentErrorLogging } from '@bingads-webui-campaign-react/global-error-options';
import { withSiteMap, getRoutePathById } from '@bingads-webui-campaign-react/with-site-map';
import { StepWizard } from '@bingads-webui-campaign-react/step-wizard';
import config from '@bingads-webui-component-legacy/config/index';
import { getVideoDeal, isDealCampaign } from '@bingads-webui-campaign-react/xandr-video-campaign-shared-components';
import localStorage from '@bingads-webui-component-legacy/storage/localStorage';
import { MmpFetchProvider } from '@bingads-webui-campaign-react/xandr-campaign';
import { XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS } from '../xandr-video-campaign-crud-scenarios';

const getXandrVideoCampaignType = () => {
  let xandrVideoCampaignType = config.get('XandrVideoCampaignType');
  if (!xandrVideoCampaignType) {
    if (localStorage.supportsStorage()) {
      xandrVideoCampaignType = localStorage.get('XandrVideoCampaignType');
      config.set('XandrVideoCampaignType', xandrVideoCampaignType);
    }
  }

  return xandrVideoCampaignType;
};

const XandrVideoCampaignCreationPageImpl = ((props) => {
  const routeToNavigateToWhenDone = getRoutePathById(props.siteMap, 'campaigns');
  const xandrVideoCampaignType = getXandrVideoCampaignType();
  const xandrVideoDeal = getVideoDeal();
  useEffect(() => {
    if (isDealCampaign()) {
      // return to objective page if user navigates to this page directly
      if (!xandrVideoDeal) {
        props.scope.save('/campaign/vnext/createcampaign/objective');
      }
    } else {
      // eslint-disable-next-line no-lonely-if
      if (!xandrVideoCampaignType) {
        props.scope.save('/campaign/vnext/createcampaign/objective');
      }
    }

    return () => {
      if (localStorage.supportsStorage()) {
        localStorage.invalidate('XandrVideoCampaignType');
      }
    };
  }, [props.scope, xandrVideoCampaignType, xandrVideoDeal]);

  return (
    <PerformanceMarkerProvider
      name={XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_CAMPAIGN_CREATION.scenarioName}
      instrumentation={props.instrumentation}
      immediateDone
    >
      <MmpFetchProvider>
        <StepWizard
          wizardScenario={XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_CAMPAIGN_CREATION}
          routeToNavigateToWhenDone={routeToNavigateToWhenDone}
          extraStepsData={{ xandrVideoCampaignType, xandrVideoDeal }}
          {...props}
        />
      </MmpFetchProvider>
    </PerformanceMarkerProvider>
  );
});

XandrVideoCampaignCreationPageImpl.propTypes = {
  siteMap: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  permissions: PropTypes.shape({}).isRequired,
  theme: PropTypes.shape({}).isRequired,
  scope: PropTypes.shape({
    save: PropTypes.func.isRequired,
  }).isRequired,
  instrumentation: PropTypes.shape({}).isRequired,
  i18n: PropTypes.shape({}).isRequired,
};

export const XandrVideoCampaignCreationPage = withSiteMap(withTheme(withComponentErrorLogging(
  XandrVideoCampaignCreationPageImpl,
  XANDR_VIDEO_CAMPAIGN_CRUD_SCENARIOS.XANDR_VIDEO_CAMPAIGN_CREATION.scenarioName
)));
